import axios from "axios";
import AuthService from "./AuthService";
import TokenService from "./TokenService";
import { CLAIM_COD_CONT, CLAIM_TOKEN_SESION_C } from "../utils/Helper/roleHelper";
import { RedireccionUrlContraseniaIdentidad, RedireccionUrlIdentidad, cambiarUrl, keyAccess, keyJwt } from "../utils/Helper/helper";
// import { access } from "fs";
// import { ConfigHelper } from "../utils/Helper/configHelper";


let type = { "Content-type": "application/json" };
// prod dns
let adminitracionUrl = "https://web21-e1.api.lasbambas.com/api/v1/";
let movilizacionUrl = "https://web22-e1.api.lasbambas.com/api/";
let identidadUrl = "https://web16-e1.api.lasbambas.com/api/v1";
let contratoUrl = "https://web23-e1.api.lasbambas.com/api/v1";
export let dispositivoUrl = "https://web27-e1.api.lasbambas.com/api/v1/";
let urlTelerik = "https://web26-e1.api.lasbambas.com/api/reports";
let urlLogin = "https://miviaje.lasbambas.com/login";
let urlBaseIdentidad = "https://miviaje.lasbambas.com/identidad";
export let urlRecuperarContraseniaIdentidad = `${urlBaseIdentidad}/recuperarContraseniaEmail/${cambiarUrl(urlLogin)}`;
let urlTelerikDescarga = "https://web26-e1.api.lasbambas.com/api";
const siteKey = "6Le2AzMpAAAAAE1QA-tdoJxLiOH2Yz7CN-JtILrV";
const clientId = "b12c97d6-8697-43cd-bfd5-301c96d70f82";
/* Axios */
const fetchIdentidad = axios.create({
  baseURL: identidadUrl,
  headers: { "Content-type": "application/json", Authorization: "Bearer " },
  withCredentials: true, // Asegura que las cookies se envíen con cada solicitud
});

const fetchAdministracion = axios.create({
  baseURL: adminitracionUrl,
  headers: type,
});

const fetchMovilizacion = axios.create({
  baseURL: movilizacionUrl,
  headers: type,
});

const fetchContrato = axios.create({
  baseURL: contratoUrl,
  headers: type,
});
const fetchDispositivo = axios.create({
  baseURL: dispositivoUrl,
  headers: { "Content-type": "application/json", Authorization: "Bearer " },
});

const fetchUrlTelerik = axios.create({
  baseURL: urlTelerik,
  headers: { "Content-type": "application/json", Authorization: "Bearer " },
});

const fetchUrlTelerikDescarga = axios.create({
  baseURL: urlTelerikDescarga,
  headers: { "Content-type": "application/json", Authorization: "Bearer " },
  // headers: type,
});

// Función para manejar la finalización de sesión
const finalizarSesion = () => {
  localStorage.removeItem(keyAccess);   // Elimina el token de acceso
  AuthService.removeToken();           // Llama al servicio para eliminar el token
  window.location.assign("/login");    // Redirige al login
};

let isRefreshing = false;  // Flag que indica si ya se está refrescando el token
// let failedQueue = [];  // Cola para almacenar las solicitudes fallidas debido a 401
let failedQueue: Array<(value: boolean) => void> = []; // Cola para almacenar las solicitudes fallidas debido a 401


//Función para refrescar el AccessToken
async function refreshAccessToken() {
  try {

    // Si ya estamos refrescando el token, las otras solicitudes se deben poner en espera
    if (isRefreshing) {
      return new Promise((resolve) => {
        failedQueue.push(resolve);  // Guardamos el 'resolve' en la cola
      });
    }
    isRefreshing = true;

    // const response = await fetchIdentidad.get("/RefreshToken");
    //añade una bandera isRefreshRequest para identificar estas llamadas.
    const response = await fetchIdentidad.get("/RefreshToken", {
      headers: { isRefreshRequest: "true" }  // Se coloca dentro de headers para evitar el error
    });

    if (response.status == 200) {
      const newAccessToken = response.data.accessToken;
      // let res = JSON.parse(response.request.response);
      if (newAccessToken != undefined && newAccessToken !== "") {
        // if (res.accessToken != undefined && res.accessToken !== "") {
        //TokenService.setToken(newAccessToken);
        // -->// console.log("Token fc para storage", newAccessToken);
        localStorage.setItem(keyJwt, JSON.stringify(newAccessToken));

        // Después de que el token se refresca con éxito
        failedQueue.forEach((callback) => callback(true));  // Resolviendo todas las promesas pendientes
        failedQueue = [];  // Limpiamos la cola después de resolver


        return true;
      }
    }
    if (response.status === 401) {
      finalizarSesion();
    }
  } catch (error) {
    console.error("Error al refrescar token", error);
    finalizarSesion();
  } finally {
    isRefreshing = false;  // Habilitar futuras solicitudes de refresco
  }
  return false;
}

/* Interceptor */
fetchIdentidad.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   localStorage.removeItem(keyAccess);
      //   AuthService.removeToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchIdentidad.interceptors.response.use(async response => {
  let t = TokenService.getToken();
  if (t) {
    const decodedToken = AuthService.getInfoToken(CLAIM_COD_CONT);
    const decodedTokenSec = AuthService.getInfoToken(CLAIM_TOKEN_SESION_C);
    if (decodedToken === "01") {
      //alert("Primer inicio de sesión: Debe cambiar su contraseña.")
      alert("Por favor, cambie su contraseña para continuar")
      //let infoUrl = `http:@localhost:3001!login/cambiarContrasenia/${decodedToken}/${t}/http:@localhost:3001!login`
      //let urlLogin = {ConfigHelper.urlLogin()}
      //let urlLogin = 'http:@localhost:3001!login'
      //let urlLogin = 'http://localhost:3001/login'
      var urlLogFinal = cambiarUrl(urlLogin);
      let email = ''
      const userDataString = localStorage.getItem('Access');
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        const userEmail = userData.email;
        email = userEmail
      } else {
        alert("No fue posible obtener el email")
      }

      //limpiar storage
      //localStorage.clear();

      //`https://teseoqas.idslatam.com/identidad/cambiarContrasenia/${email}/${t}/https:@mmg-bso-dev-web25e3.azurewebsites.net!login`);
      window.location.assign(RedireccionUrlIdentidad(urlBaseIdentidad, email, decodedTokenSec, urlLogFinal));
      //window.location.assign('http://localhost:3000/identidad/cambiarContrasenia/http:@localhost:3001!login');
    }
    if (decodedToken === "02") {
      alert("Contraseña expirada, debe actualizar su contraseña.")
      //let urlLogin = 'http://localhost:3001/login'
      var urlLogFinal = cambiarUrl(urlLogin);
      // let urlLogin = 'http:@localhost:3001!login'
      let email = ''
      const userDataString = localStorage.getItem('Access');
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        const userEmail = userData.email;
        email = userEmail
      } else {
        alert("No fue posible obtener el email")
      }

      //limpiar storage
      //localStorage.clear();

      window.location.assign(RedireccionUrlContraseniaIdentidad(urlBaseIdentidad, email, decodedTokenSec, urlLogFinal));
    }
  }
  return response;
}, async error => {
  if (error?.response?.status === 403) {
    finalizarSesion();
    return Promise.reject(error);
  }
  const originalRequest = error.config;
  // Si la petición ya es un intento de refreshToken, evitar reintentar
  if (originalRequest.headers?.isRefreshRequest) {
    finalizarSesion();
    return Promise.reject(error);
  }
  if (error?.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    const success = await refreshAccessToken();
    if (success) {
      originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
      return axios(originalRequest);
    }
  }
  if (error?.response?.status === 401) {
    finalizarSesion();
  }
  return Promise.reject(error);
});

fetchAdministracion.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();

      // if (isExp) {
      //   localStorage.removeItem(keyAccess);
      //   // return AuthService.removeToken();
      //   AuthService.removeToken();
      //   //return Promise.reject(new Error("Token expirado"));
      // }

      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);
fetchAdministracion.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status || 500;
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);

fetchMovilizacion.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   // localStorage.removeItem(keyAccess);
      //   // AuthService.removeToken();
      //   await refreshAccessToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },

  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);
fetchMovilizacion.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);

fetchContrato.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   // localStorage.removeItem(keyAccess);
      //   // AuthService.removeToken();
      //   await refreshAccessToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },

  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchContrato.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status || 500;
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);

fetchDispositivo.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   // localStorage.removeItem(keyAccess);
      //   // AuthService.removeToken();
      //   await refreshAccessToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },

  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchDispositivo.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status || 500;
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);

fetchUrlTelerik.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   // localStorage.removeItem(keyAccess);
      //   // AuthService.removeToken();
      //   await refreshAccessToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchUrlTelerik.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status || 500;
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);

fetchUrlTelerikDescarga.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      // let isExp = AuthService.verifiedExp();
      // if (isExp) {
      //   // localStorage.removeItem(keyAccess);
      //   // AuthService.removeToken();
      //   await refreshAccessToken();
      // }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchUrlTelerikDescarga.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status || 500;
    if (error?.response?.status === 403) {
      finalizarSesion();
    }
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await refreshAccessToken();
      if (success) {
        originalRequest.headers["Authorization"] = `Bearer ${TokenService.getToken()}`;
        return axios(originalRequest);
      }
    }
    if (error?.response?.status === 401) {
      finalizarSesion();
    }
    return Promise.reject(error);
  }
);
export {
  fetchIdentidad,
  fetchAdministracion,
  fetchMovilizacion,
  fetchContrato,
  fetchDispositivo,
  clientId,
  urlLogin,
  /* Teseo */
  urlTelerik,
  fetchUrlTelerik,
  fetchUrlTelerikDescarga,
  siteKey,
  identidadUrl,
};
